// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HiX8JSfm03aRDT6mAxYy {
  background: var(--grey-color-10);
  padding: 32px;
}

.dMtM5c2d_3iOlf9cb4io {
  background-color: var(--grey-gradient-start-color-10);
  padding: 32px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CohortCapabilitiesLeadersV2/CohortCapabilitiesLeadersV2.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAA;EACA,aAAA;AACF;;AAEA;EACE,qDAAA;EACA,aAAA;AACF","sourcesContent":[".container {\n  background: var(--grey-color-10);\n  padding: 32px;\n}\n\n.heatmapTableContainer {\n  background-color: var(--grey-gradient-start-color-10);\n  padding: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HiX8JSfm03aRDT6mAxYy`,
	"heatmapTableContainer": `dMtM5c2d_3iOlf9cb4io`
};
export default ___CSS_LOADER_EXPORT___;
